import React from 'react';
import PropTypes from 'prop-types';

import {Box, Checkbox, TextField, Typography, Stack} from 'views/components';
import {translate} from 'views/module';

const CheckboxInput = (props) => {
  const {
    questionData,
    options,
    values,
    otherText,
    onToggle,
    onOtherTextChange,
  } = props;

  return (
    <Box>
      {
        questionData.helpText &&
        <Typography>
          {questionData.helpText}
        </Typography>
      }
      <Stack spacing='16px'>
        {
          options.map((option) => (
            <Box key={option.value}>
              <Box>
                <Checkbox
                  label={
                    <Typography
                      sx={{
                        fontWeight: 400,
                        fontSize: '16px',
                        lineHeight: '150%',
                      }}
                    >
                      {option.label}
                    </Typography>
                  }
                  checked={values.includes(option.value)}
                  onChange={(checked) => onToggle(option.value, checked)}
                  formControlSx={{
                    alignItems: 'flex-start',
                    display: 'flex',
                    flexDirection: 'row',
                    textAlign: 'left',
                  }}
                  checkBoxSx={{
                    alignSelf: 'flex-start',
                    mt: '-9px',
                  }}
                  sx={{
                    'color': '#DA7955',
                    '&.Mui-checked': {
                      color: '#DA7955',
                    },
                  }}
                />
              </Box>
              {
                option.isOther && values.includes(option.value) &&
                <TextField
                  placeholder={translate('form.Inputs.OtherPlaceholder')}
                  value={otherText || ''}
                  onChange={(value) => onOtherTextChange(value)}
                  fullWidth
                  slotProps={{
                    input: {
                      sx: {
                        'borderRadius': '12px',
                        'fontWeight': 400,
                        'fontSize': '16px',
                        'lineHeight': '150%',
                      },
                    },
                  }}
                />
              }
            </Box>
          ))
        }
      </Stack>
    </Box>
  );
};

CheckboxInput.propTypes = {
  questionData: PropTypes.shape({
    helpText: PropTypes.string,
  }).isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.node.isRequired,
    isOther: PropTypes.bool.isRequired,
  })).isRequired,
  values: PropTypes.arrayOf(PropTypes.string).isRequired,
  otherText: PropTypes.string,
  onToggle: PropTypes.func.isRequired,
  onOtherTextChange: PropTypes.func.isRequired,
};

export default CheckboxInput;
